import { toast } from '@/components/toast';
import { ITranslation, ITranslationGroup, Subject, TranslationStatus } from '@d-id/types';
import { atom } from 'recoil';

export const uploadingTranslationGroupsAtom = atom<ITranslationGroup[]>({
    key: 'uploading-translations',
    default: [],
});

export const GET_TRANSLATIONS_KEY = 'GET_TRANSLATIONS_KEY';
export const GET_TRANSLATION_GROUPS_KEY = 'GET_TRANSLATION_GROUPS_KEY';
export const GET_TRANSLATION_GROUP_KEY = 'GET_TRANSLATION_GROUP_KEY';

enum ERROR_KINDS {
    TextModerationError = 'TextModerationError',
    CelebrityDetectedError = 'CelebrityDetectedError',
    FaceError = 'FaceError',
    UploadFileError = 'UploadFileError',
    MissingAudioError = 'MissingAudioError',
}

export const handlePartialGroupEvent = (body?: any) => {
    const totalTranslationCount = body?.translations?.length;
    const doneTranslationCount = body?.translations?.filter((t: ITranslation) => t.status === TranslationStatus.Done).length;
    const errorTranslationCount = body?.translations?.filter((t: ITranslation) => t.status === TranslationStatus.Error).length;

    const isFirstDone = totalTranslationCount > 1 && doneTranslationCount === 1 && errorTranslationCount === 0;
    const isFinishedWithErrors =
        totalTranslationCount > 1 && errorTranslationCount > 0 && totalTranslationCount === doneTranslationCount + errorTranslationCount;

    if (isFirstDone) {
        toast.success({ title: 'Video translated successfully!' });
    } else if (isFinishedWithErrors) {
        toast.success({ title: `Video translation done - ${doneTranslationCount} succeeded, ${errorTranslationCount} failed.` });
    }
};

export const handleTranslationErrors = (subject: Subject, body?: any) => {
    if (subject === Subject.TranslationGroupPostError) {
        const errorKind = body?.error?.kind;

        if (errorKind === ERROR_KINDS.FaceError) {
            toast.error({ title: 'No face detected in your uploaded footage', toastId: `create-translation-error` });
            return;
        }
        if (errorKind === ERROR_KINDS.CelebrityDetectedError) {
            toast.error({
                title: 'Famous figure detected',
                toastId: `create-translation-error`,
                message: 'The footage you’ve uploaded contains a famous figure, which is not according to our content guidelines.',
            });
            return;
        }

        if (errorKind === ERROR_KINDS.TextModerationError) {
            toast.error({
                title: 'Content moderation error',
                toastId: `create-translation-error`,
                message: 'The footage you’ve uploaded contains offensive content, which is not according to our content guidelines.',
            });
            return;
        }

        if (errorKind === ERROR_KINDS.UploadFileError) {
            toast.error({
                title: 'Failed to upload file',
                toastId: `create-translation-error`,
            });
            return;
        }
        if (errorKind === ERROR_KINDS.MissingAudioError) {
            toast.error({
                title: 'Input video has no audio',
                toastId: `create-translation-error`,
            });
            return;
        }
        toast.error({ title: 'Could not create translation videos. Please try a different video', toastId: `create-translation-error` });
    }
};
